import React, { useState } from 'react'
import './react-tagsinput.css'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import './content.scss'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

const ImageCropper = (props) => {
  const { openModal, imageCropObj, handleCallback, closeModalHandle } = props
  const [imageRef, setImageRef] = useState()

  const [crop, setCrop] = useState(imageCropObj.crop)

  const makeClientCrop = async () => {
    if (imageRef && crop.width && crop.height) {
      const { url, blob } = await getCroppedImg(imageRef, crop, imageCropObj.imageName)
      handleCallback(url, blob, imageRef)
    } else {
      alert('Please crop the image')
    }
  }

  console.log('imageCropObj', imageCropObj)

  const getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement('canvas')
    const pixelRatio = window.devicePixelRatio
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const ctx = canvas.getContext('2d')

    canvas.width = crop.width * pixelRatio * scaleX
    canvas.height = crop.height * pixelRatio * scaleY

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    ctx.imageSmoothingQuality = 'high'

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    )

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error('Canvas is empty')
            return
          }
          blob.name = fileName
          resolve({ url: window.URL.createObjectURL(blob), blob })
        },
        imageCropObj?.imageType,
        1,
      )
    })
  }

  console.log(crop)

  return (
    <CModal visible={openModal} size={'xl'} scrollable={true} className={'modal-fullscreen'}>
      <CModalHeader className="px-5 py-4">
        <CModalTitle>Crop image</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <ReactCrop
          src={imageCropObj.src}
          crop={crop}
          scale={1}
          ruleOfThirds
          onImageLoaded={(imageRef) => setImageRef(imageRef)}
          // onComplete={(cropConfig) => makeClientCrop(cropConfig)}
          onChange={(cropConfig) => setCrop(cropConfig)}
        />
      </CModalBody>
      <CModalFooter>
        <CButton
          className="text-white"
          color="danger"
          style={{ marginRight: '2rem' }}
          onClick={closeModalHandle}
        >
          Cancel
        </CButton>
        <CButton className="text-white" color="info" onClick={makeClientCrop}>
          Crop
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ImageCropper
